var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"developing-main"},[_c('div',{staticClass:"text-info"},[_vm._v(" 页面开发中，请耐心等待...... ")])])
}]

export { render, staticRenderFns }